//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { DepartmentModel, ProgramModel } from '@app/catalog';

@Component({
  selector: 'assign-department-to-program',
  standalone: false,
  templateUrl: './assign-department-to-program.component.html',
  styleUrl: './assign-department-to-program.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignDepartmentToProgramComponent {
  onCancelAssignment = output();

  programs = input.required<ProgramModel[]>();
  assignedDepartments = input.required<DepartmentModel[]>();
  departments = input.required<DepartmentModel[]>();



  public applyAssignment() {

  }
}
